export enum FeesErrorDescription {
  /** @deprecated Split into TERMS_NOT_ACCEPTED and NO_ENABLED_INTEGRATION; kept for cached responses from older servers. */
  ONBOARDING_NOT_FINISHED = "The shop didn't finish onboarding",
  TERMS_NOT_ACCEPTED = "The merchant hasn't accepted terms and conditions",
  NO_ENABLED_INTEGRATION = "The shop has no enabled ecommerce platform integration",
  SHOP_DISABLED_COVERAGE = "The shop disabled coverage",
  STORE_HAS_MISCONFIGURED_ONBOARDING = "The store has misconfigured onboarding, Store has no coverage price",
  INSUFFICIENT_PERMISSIONS_TO_ACCESS_ECOMMERCE_PLATFORM_RESOURCES = "Insufficient permissions to access ecommerce platform resources",
  THROTTLED = "Throttled",
  PRODUCT_LOCKED = "Product modifications are locked",
}

export class ProductLockedError extends Error {
  constructor() {
    super(FeesErrorDescription.PRODUCT_LOCKED);
  }
}

export const SilentExpectedErrors = [
  FeesErrorDescription.ONBOARDING_NOT_FINISHED,
  FeesErrorDescription.TERMS_NOT_ACCEPTED,
  FeesErrorDescription.NO_ENABLED_INTEGRATION,
  FeesErrorDescription.SHOP_DISABLED_COVERAGE,
  FeesErrorDescription.PRODUCT_LOCKED,
];
